import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon, SmartphoneIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { MoreTestimonials } from './MoreTestimonials';
const plan = {
  name: '📘 PROTOCOLLO ATLETA 360',
  ideal: 'Professionisti e atleti che desiderano gestire la riabilitazione con un metodo clinico visivo.',
  was: '54€',
  now: '27',
  features: ['6 Volumi Completi', 'Protocolli Spalla, Ginocchio, Caviglia, Schiena, Anca e Braccia', 'Quadri reali di "Return to Sport"', '5 Bonus Gratuiti inclusi', 'Garanzia di rimborso di 7 giorni', '♾️ Accesso a vita e aggiornamenti gratuiti'],
  cta: 'Ottieni il Metodo Atleta 360™ ora'
};
const trust = [{
  icon: LockIcon,
  label: 'Pagamento 100% sicuro'
}, {
  icon: ZapIcon,
  label: 'Accesso istantaneo'
}, {
  icon: CreditCardIcon,
  label: 'Credito / Debito'
}, {
  icon: SmartphoneIcon,
  label: 'Android & iOS'
}];
export function Pricing() {
  return <section id="pricing" aria-label="Prezzo" className="bg-radial-glow w-full scroll-mt-20 overflow-x-hidden" data-id="element-118" data-mp="3vzynqjgdld45">
      <div className="mx-auto w-full max-w-5xl px-5 py-12" style={{
      paddingTop: "15px",
      paddingBottom: "15px"
    }} data-id="element-119" data-mp="4scl8u5e7gov">
        <div className="mx-auto mb-6 max-w-md text-center" data-id="element-120" data-mp="9t0cngxj9zjm">
          <p className="font-display text-xl font-black text-plum" data-id="element-121" data-mp="erle1joiup9n">🔥 Offerta limitata — Presto terminerà!</p>
          <p className="mt-2 text-sm font-semibold text-plum/70" data-id="element-122" data-mp="3da0dbwp3v7xc">
            ⚠️ Dopo, il prezzo tornerà a 54€. Questa tariffa non tornerà più.
          </p>
          <p className="mt-2 inline-flex rounded-full border border-blush/50 bg-blush-soft px-4 py-1.5 text-xs font-bold text-blush-deep" data-id="element-123" data-mp="3n753e7m2nnjf">
            🎟️ Solo 12 posti rimasti a questo prezzo!
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto flex w-full max-w-md flex-col items-center rounded-3xl border border-grape/30 bg-white px-6 py-6 text-center shadow-[0_24px_60px_-28px_rgba(21,128,61,0.45)]" data-id="element-124" data-mp="2uizj1lyxk0k4">
          <h3 className="font-display text-lg font-black text-plum" data-id="element-125" data-mp="318im90je0n8c">{plan.name}</h3>
          <p className="mt-2 text-sm text-plum/60" data-id="element-126" data-mp="2w8d0g0zstuy6">
            <span className="font-semibold text-plum/80" data-id="element-127" data-mp="28hh54tw4whm6">Ideale per:</span> {plan.ideal}
          </p>

          <div className="mt-6" data-id="element-128" data-mp="23jpcfxno0rgx">
            <span className="text-[20px] font-medium text-plum/40 line-through" data-id="element-129" data-mp="23kgx4dfq54sf">{plan.was}</span>
            <div className="flex w-full justify-center py-2" data-id="element-130" data-mp="2ihrf85mvh8x4">
              <span className="relative inline-block font-display leading-none" data-id="element-131" data-mp="2dgk6a38zu3ov">
                <span className="text-grape-shine text-[74px] font-black leading-none" style={{
                fontFamily: "Merriweather, serif"
              }} data-id="element-132" data-mp="3tv3c1wk7sr9s">
                  {plan.now}
                </span>
                <span className="absolute left-full top-1/2 ml-2 -translate-y-1/2 text-[45px] font-black leading-none text-grape" style={{
                fontFamily: "Merriweather, serif"
              }} data-id="element-133" data-mp="3oylebgnaxt6y">
                  €
                </span>
              </span>
            </div>
            <p className="mt-1 text-xs font-semibold text-grape" data-id="element-134" data-mp="3ngejjjvl6m08">
              · Pagamento unico · Accesso a vita ·
            </p>
          </div>

          <ul className="mt-6 w-full flex-1 space-y-3 text-left" data-id="element-135" data-mp="j0v88fh83wwz">
            {plan.features.map(f => <li key={f} className="flex items-start gap-2.5 text-sm text-plum/80" data-id="element-136" data-mp="j37s4y6jkhco">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grape" strokeWidth={3} data-id="element-137" data-mp="o22g0ejd8w3n" />
                {f}
              </li>)}
          </ul>

          <div className="mt-7 flex w-full justify-center" data-id="element-138" data-mp="e9d9ly2oa8f6">
            <CTAButton size="md" data-id="element-139" data-mp="e7sfg9k9srhu">{plan.cta}</CTAButton>
          </div>

          <p className="mt-3 text-[11px] font-semibold text-plum" data-id="element-140" data-mp="11y6b0a22d8h6">
            Risparmi 141€ (84% di sconto)
          </p>

          <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-medium text-plum/55" data-id="element-141" data-mp="16sah6r3i9ch7">
            {trust.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-142" data-mp="3aas5nntcl747">
                <Icon className="h-4 w-4 text-grape" data-id="element-143" data-mp="359mbdlk1hbsk" />
                {label}
              </span>)}
          </div>
        </motion.div>

        <MoreTestimonials data-id="element-144" data-mp="1sm76vt9dla3" />

        <div className="mx-auto mt-12 flex w-full max-w-2xl items-start gap-3 rounded-2xl border border-grape/20 bg-white/80 p-5 text-left" data-id="element-145" data-mp="1svpdx82ao58">
          <ShieldCheckIcon className="mt-0.5 h-6 w-6 shrink-0 text-grape" data-id="element-146" data-mp="3szox7jxd1liq" />
          <p className="text-[15px] leading-relaxed text-plum/75" data-id="element-147" data-mp="3o6vtmzdmoj88">
            <span className="font-display font-bold text-plum" data-id="element-148" data-mp="3k74zqmst1mzh">
              🛡️ Garanzia di Rimborso di 7 Giorni.
            </span>{' '}
            Se nei primi 7 giorni ritieni che il sistema non soddisfi le tue esigenze, chiedi il
            rimborso e ti restituiremo il 100% dei tuoi soldi. SIGMA SMART™ si impegna per i tuoi
            risultati.
          </p>
        </div>
      </div>
    </section>;
}